import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=2a713b52&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&id=2a713b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a713b52",
  null
  
)

export default component.exports